import userHasCustomTourOperatorsOverwrite from './userHasCustomTourOperatorsOverwrite'
import { userCustomTourOperatoreCode as userCustomTOPCodeSessionKey } from '../../config/sessionStorage'

export default () => {
  if (!userHasCustomTourOperatorsOverwrite()) return false

  return (
    sessionStorage[userCustomTOPCodeSessionKey] !== undefined &&
    sessionStorage[userCustomTOPCodeSessionKey] !== 'undefined' &&
    sessionStorage[userCustomTOPCodeSessionKey] !== 'null'
  )
}
